<template>
  <div style="margin: 0 auto; max-width: 960px;">
    <DashboardNav /> 
    <DarkOverlay />
    <main class="dashboard">
      <div class="form-group stacked-labels checkboxes">
      </div>
      <ToolBar
        :showMoveRally=true
        :options="toolbarOptions"
        v-on:perform="perform"
      />
        <section  id="infLoadArea" class="content-area" v-if="this.rallySearchResults && this.rallySearchResults.length > 0">
          <Rally
            v-for="(rally, $index) in this.rallySearchResults"
            :key="$index"
            :rally="rally"> 
          </Rally>
        </section>
      <section class="content-area"   v-if="!(this.rallySearchResults && this.rallySearchResults.length > 0 && this.isDashboardLoaded)">
        <draggable v-show="allowMoveRallies" v-model="this.rallyListing" item-key="membership.id" group="people" @start="onDragStart" @end="onDragEnd">
          <template #item="{ element, index }">
          <Rally
          :rally="element" 
          :key="index">
          </Rally>
          </template>
        </draggable>
        <Rally v-show="!allowMoveRallies"
            v-for="(rally, $index) in this.rallyListing"
            :key="$index"
            :rally="rally">
        </Rally>
        <div class="infinite-loading-container" > 
        <infinite-loading v-if="!isComplete" ref="infLoad" @infinite="infiniteHandler" :slots="{ complete: ' ' }"/>
        <span ><br/> <i @click="reloadPage" class="fa fa-sync" style="cursor:pointer; display:inline-flex; flex-direction:column; align-items:center;"><div style="font-family:sans-serif; line-height:1.4; margin-top:4px; white-space:nowrap;">Refresh</div></i><br/><br/><br/></span>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { router } from "../common";
import { findDefaultChannelOfType } from "../common";
import RallyPaginationMixin from "../components/RallyPaginationMixin";
import { eventBus } from "../main.js";  
import { PushNotification } from "@capacitor/core";
import { userInfo, syncTimezone } from "../common/user-info";
import {isMobile} from "../common/utils";
import { isMoment } from "moment";
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";


export default {
  mixins: [RallyPaginationMixin],
  name: "DashboardPage",
  data() {
    return {
      //parentRallyId: null,
      drag: false,
      page: 1,
      isDashboardLoaded: false,
      isComplete:false,
      // infiniteRallies: [],
      tempSortOrder: {},
      show_create: false,
      polling_int: null,
      newMessage: {
        title: null,
        body: null
      }
    };
  },
  computed: {
    ...mapState("rallies", [
      "allRallies",
      "myRallies",
      "rallyChannelsByRallyId",
      "ralliesByParent",
      "allRalliesByRallyId", "resultCountByRallyId", "rallySearchResults", "moveRallies"
    ]),
    ...mapState("contents", ["contentById"]),
    ...mapState("user", ["status", "usersById"]),
    ...mapState("memberships", ["myMembershipByRallyId"]),
    allowMoveRallies(){
      return !isMobile() ||  this.moveRallies 
    },
    rallyListing() {
      //if (!this.isDashboardLoaded) {
        //return []; // or any default value that signifies loading state
      //}
      let rs = []
      if (this.parentRallyId) {
        rs = [...this.myRallies[parseInt(this.parentRallyId)]]; // Copying the array using spread operator
      } else {
        rs = [...this.myRallies]; // Copy the myRallies array
      }

      // Remove entries where rally attribute is missing
      rs = rs.filter(item => item?.rally?.attributes?.title);
      rs = rs.filter(item => item?.rally?.attributes?.viewable);
      rs = rs.filter(item => (item?.rally?.attributes?.status == "Active") || (item?.rally?.attributes?.status == "Archived" && item?.membership?.attributes?.role == "Owner" && item?.membership?.attributes?.status == "Active") );

      if (rs && Array.isArray(rs)) {
       rs = this.membershipSort(rs)
      } else {
        console.warn("rs is not an array or is undefined");
      }
      
      return rs
    },
    parentRallyId() {
      return this.$route.params.parentRallyId;
    },
    resultCount() {
      return this.resultCountByRallyId[this.parentRallyId > 0 ? this.parentRallyId : 1]
    },
    toolbarOptions() {
      let options = new Array();
      //options.push({ onClick: "openSearch", params: { context: 'my rallies' }, icon: "fa-search", label: "My Rallies" });
      options.push({ onClick: "openSearch", params: { context: 'all rallies' }, icon: "fa-search", label: "Search" });
      options.push({ onClick: "newRally", params: { }, icon: "fa-plus-circle", label: "Create Rally" });
      options.push({ onClick: "refreshAll", params: { }, icon: "fa-sync", label: "Refresh" });
      return options;
    },
    /*filteredRallies() {
      return this.allRallies.filter(function(rally) {
        return rally.rally.attributes['child-count'] == 0
      });
    }*/
  },
  created() {
    syncTimezone();
    if (this.myRallies && this.myRallies.length > 1) {
      this.isDashboardLoaded = true
    } else {
      console.log("fetching all the rallies")
      this.fetchDashboardRallies()
    }
    this.clearRallySearchResults();
  },

  methods: {
    ...mapActions("rallies", ["clearRallyState", "fetchMyRalliesWithInfo", "clearRallySearchResults"]),
    ...mapActions("user", ["registerUserDevice", "fetchUsersById"]),
    ...mapActions("memberships", ["fetchMembersByRally", "changeSort"]),
    membershipSort(rs){
      return rs.sort((a, b) => {
          if ( a?.rally?.attributes && a?.membership?.attributes && b?.rally?.attributes && b?.membership?.attributes){
            let sa = this.tempSortOrder[a.membership.id] != null ? this.tempSortOrder[a.membership.id] : a.membership.attributes['sort-order']
            let sb = this.tempSortOrder[b.membership.id] != null ? this.tempSortOrder[b.membership.id] : b.membership.attributes['sort-order']
            if (sa ==  null){
              sa = 10000
            }
            if (sb == null){
              sb = 10000
            }
            if (a.rally.attributes.status == 'Archived'){
              sa = 10001
            }
            try{
              if (b.rally.attributes.status == 'Archived'){
                sb = 10001
              }
            } catch (e){
              console.log(e)
            }
            if (sa < sb){
              return -1
            } else if (sa > sb) {
              return 1
            }
            return 0;
          } else {
            console.warn("Missing rally attributes:", a);  
            return 0;
          }
        });
      },
    onDragStart(evt) {
      this.drag = true; // Set drag state to true when dragging starts
      console.log("Drag started:", evt);
    },
    async onDragEnd(evt) {
      this.drag = false; // Reset drag state
      console.log("Drag ended:", evt);

      // Example: Handle moved item
      const movedItem = this.rallyListing[evt.oldIndex];
      const replacedItem = this.rallyListing[evt.newIndex];
      await this.handleItemMoved(evt.oldIndex, evt.newIndex, movedItem, replacedItem);
    },
    async handleItemMoved(oldIndex, newIndex, movedItem, replacedItem) {
      eventBus.emit('overlayOn')
      this.tempSortOrder = {}
      this.tempSortOrder[movedItem.membership.id] =  newIndex 
      this.tempSortOrder[replacedItem.membership.id] =  newIndex + 0.1
      let rs = [...this.myRallies];
      let sortedMembershipIds = this.membershipSort(rs).map(obj => obj.membership.id)
      console.log("moving items")
      console.log(sortedMembershipIds)
      await this.changeSort({membershipIdOrdering: this.membershipSort(rs)})
      eventBus.emit('overlayOff')
    },

    reloadPage(){
      location.reload()
    },
    async fetchDashboardRallies() {
      // TODO - clear out the rally state whenever this page is loaded due to the fact that
      // rallies that the user may not be an explicit member of may be loaded into the state
      // as the user clicks on the rabbit-trail links to Hubs
      // Eventually we should keep the state of the rallies that the user is a member of in a separate state
      //await this.clearRallyState()
      console.log("FETCH DASHBOARD RALLIES")
      await this.fetchMyRalliesWithInfo({});    
      this.isDashboardLoaded = true
    },
    getContentById(id) {
      return this.contentById[parseInt(id)]
        ? this.contentById[parseInt(id)]
        : this.contentById[-1];
    },

    getContentAttribute(id, attname) {
      var c = this.getContentById(id);
      if (c && c.attributes && c.attributes[attname]) {
        return c.attributes[attname];
      } else {
        return "";
      }
    },

    async loadNextPage(){
      await this.fetchMyRalliesWithInfo({});
    },
    async infiniteHandler($state) {
      let beforesize = this.rallyListing.length
      await this.fetchMyRalliesWithInfo({});
      if (beforesize == this.rallyListing.length){
        this.isComplete = true;
        $state.complete();
      } else {
        $state.loaded();
      }
    },
    log(message) {
      this.$log.debug(message);
    },
    newRally() {
      router.push('/start');
    },
    perform(method, params) {
      params ? this[method](params) : this[method]();
    },
  }
};
</script>
<style scoped>
.refresh-centered {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; /* or any specific height you need */
    text-align: center;
    font-family: "Lato", sans-serif;
}
.refresh-font {
  font-family: "Lato", sans-serif;
}

</style>
